
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiClassiGrid extends Serenity.EntityGrid<UtentiProdottiClassiRow, any> {
        protected getColumnsKey() { return UtentiProdottiClassiColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiClassiDialog; }
        protected getIdProperty() { return UtentiProdottiClassiRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiClassiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiClassiRow.localTextPrefix; }
        protected getService() { return UtentiProdottiClassiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.idUtenteProdotto > 0);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            }

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            return buttons;
        }

        /**
         * This method is called when New Item button is clicked.
         * By default, it calls EditItem with an empty entity.
         * This is a good place to fill in default values for New Item button.
        */
        protected addButtonClick() {
            this.editItem(<UtentiProdottiClassiRow>{
                IdUtenteProdotto: this.idUtenteProdotto,
                IdUtente: this.idUtente
            });
        }

        getAddButtonCaption() {
            return "Aggiungi classe";
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);

            var item = itemType as UtentiProdottiClassiRow;

            var theDialog: UtentiProdottiClassiDialog = dialog;
            theDialog.idProdotto = this.idProdotto;
            theDialog.idUtenteProdotto = this.idUtenteProdotto;
            theDialog.idProdottoClasse = item.IdProdottoClasse;

            Serenity.SubDialogHelper.bindToDataChange(theDialog, this, (e, dci) => {
                // Refresh delle grid associate.
                this.parent.esperienzeGrid.refresh();
            }, true);
        }

        // ///////////////////////////////////////////////////////////////
        private _idUtenteProdotto: number;

        get idUtenteProdotto() {
            return this._idUtenteProdotto;
        }

        set idUtenteProdotto(value: number) {
            if (this._idUtenteProdotto != value) {
                this._idUtenteProdotto = value;
                this.setEquality(UtentiProdottiClassiRow.Fields.IdUtenteProdotto, value);
                this.refresh();
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _idProdotto: number;

        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _idUtente: number;

        get idUtente() {
            return this._idUtenteProdotto;
        }

        set idUtente(value: number) {
            if (this._idUtente!= value) {
                this._idUtente= value;
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _parent: UtentiProdottiConProprietaDialog;

        get parent() {
            return this._parent;
        }

        set parent(value: UtentiProdottiConProprietaDialog) {
            if (this._parent != value) {
                this._parent = value;
            }
        }
    }
}